import React, { useEffect } from "react";
import { Target, Zap, Users } from "lucide-react";
import "./About.css";

const About = () => {
  useEffect(() => {
    document.title = "About InnoRock – AI Automation for Real Businesses";

    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "InnoRock is a Canada-based AI automation company helping businesses eliminate repetitive manual work using simple AI agents."
      );
    }

    const canonical = document.querySelector("link[rel='canonical']");
    if (canonical) {
      canonical.setAttribute("href", "https://innorock.org/#about");
    }
  }, []);

  const pillars = [
    {
      icon: <Target className="pillar-icon" />,
      title: "Strategy",
      description: "AI Readiness & Roadmaps",
    },
    {
      icon: <Zap className="pillar-icon" />,
      title: "Implementation",
      description: "Automation & Integration",
    },
    {
      icon: <Users className="pillar-icon" />,
      title: "Enablement",
      description: "Training & Support",
    },
  ];

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-inner">
          {/* About text */}
          <div className="about-text">
            <h2>About InnoRock</h2>
            <p>
              We&apos;ve evolved from chatbot development to full-spectrum AI & IT consulting.
              Our mission is to{" "}
              <span className="highlight">
                empower businesses to operate intelligently
              </span>{" "}
              with AI and automation — making advanced technology accessible and practical for
              companies of all sizes.
            </p>
          </div>

          {/* Three Pillars */}
          <div className="pillar-grid">
            {pillars.map((pillar, index) => (
              <div key={index} className="pillar-card">
                <div className="pillar-icon-box">{pillar.icon}</div>
                <h3>{pillar.title}</h3>
                <p>{pillar.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
export { About };
